var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckLoginOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.75,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#CBCBCB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0807 5.58594L6.46615 11.2572L3.91406 8.67937",
    stroke: "white",
    strokeWidth: 1.53,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckLoginOff);
export default __webpack_public_path__ + "static/media/CheckLoginOff.c604ea3681d3f95b8f3cc9eafd865653.svg";
export { ForwardRef as ReactComponent };